import{createSidecarMedium as e}from"../../../../../use-sidecar@1.1.2_@types_react@18.3.12_react@18.3.1/node_modules/use-sidecar/dist/es2015/medium.js";var s=e();export{s as effectCar};
//# sourceMappingURL=medium.js.map
